import React, { useContext, useEffect, useRef, useState } from 'react'
import axios from 'axios'
import { baseUrl, path } from '../../constants'
import { Oval } from 'react-loader-spinner'
import { appContext } from '../../Context/appProvider'
import {useNavigate, useParams} from 'react-router-dom'
import { useLocation } from "react-router-dom";
import { api } from '../../api'

export default function AddSubCategory() {
     const [isSubmitting, setIsSubmitting] = useState(false)
     const location = useLocation();    
     const navigate = useNavigate()
    const { subCategory } = location.state || {};
     const [name, setName] = useState(subCategory?.name)
     const {setNotification} = useContext(appContext)
     const {categoryId} = useParams()

     const submit = () => {
        setIsSubmitting(true)
        api(subCategory ? path.editSubCategory : path.addSubCategory + '/' + categoryId, {
            method: subCategory ? 'patch' : 'post',
            data: {
                name, id: subCategory?.id
            }
        }).then(response => {
            setIsSubmitting(false)
            if(response.data.success){
                setNotification({
                    message: 'Sub Category successfully ' + subCategory ? 'updated' : 'created',
                    visible: true,
                    type: 'success'
                })
                navigate(-1)
            }
        }).catch(e => {
            console.log(e)
            setIsSubmitting(false)
            setNotification({
                message: 'Unkown error occured!',
                visible: true,
                type: 'error'
            })
        })
     }

    return (
    <div className='flex flex-col gap-5 h-full w-full bg-white rounded-sm p-4'>
        <h2 className='text-black text-[18px] font-bold'>{subCategory ? 'Edit' : 'Add'} Sub Category</h2>
        <div className='flex flex-col gap-3'>
            <div className='flex flex-col gap-3 w-[400px]'>
                <input onChange={event => setName(event.target.value)} placeholder='Sub Category Name' type='text' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-full' value={name} />
                <button onClick={submit} disabled={isSubmitting || !name} type='submit' className={`${(!name) ? 'bg-[#a3a3a3]' : 'bg-main'} text-white text-[14px] w-full p-2 flex items-center justify-center`}>
                {isSubmitting ? (
                    <Oval
                        visible={true}
                        height="21"
                        width="21"
                        color="#198754"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        strokeWidth={3}
                    />
                ) : 'Save'}
                </button>
            </div>
        </div>
    </div>
    )
}

function UploadItem({ file, setUploading, setSources }){
    const [loading, setLoading] = useState(true)
    const [source, setSource] = useState(null)

    useEffect(() => {
        setLoading(true)
        let form  = new FormData()
        form.append('file', file)
        console.log(file)
        axios(baseUrl + path.uploadFile + '?to=images', {
            data: form,
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            if(response.data.success){
                setLoading(false)
                setSource(response.data.source)
                setSources(response.data.source)
            }
        })
    }, [file])

    return (
        <div className='w-[50px] h-[50px] border-[#00000050] border-solid border-[1px] p-1 flex items-center justify-center'>
            {loading ? (
                <Oval
                    visible={true}
                    height="24"
                    width="25"
                    color="#198754"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    strokeWidth={3}
                /> ): (
                    <img src={baseUrl + source} alt='source' className='w-full h-full object-contain'  />
                )}
        </div>
    )
}